import { common } from './common.icons';

export const IconShoppingBag = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-shopping-bag ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 25 25"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
    >
      <path d="M16.6667 10.416C16.6667 11.5212 16.2277 12.5811 15.4463 13.3625C14.6649 14.144 13.6051 14.583 12.5 14.583C11.3949 14.583 10.3351 14.144 9.55372 13.3625C8.77232 12.5811 8.33333 11.5212 8.33333 10.416M3.23181 6.28464H21.7672M3.54167 5.69378C3.2712 6.05442 3.125 6.49307 3.125 6.94388V20.8335C3.125 21.3861 3.34449 21.9161 3.73519 22.3068C4.12589 22.6975 4.6558 22.917 5.20833 22.917H19.7917C20.3442 22.917 20.8741 22.6975 21.2648 22.3068C21.6555 21.9161 21.875 21.3861 21.875 20.8335V6.94388C21.875 6.49307 21.7288 6.05442 21.4583 5.69378L19.375 2.91543C19.1809 2.65667 18.9293 2.44664 18.64 2.30199C18.3507 2.15734 18.0318 2.08203 17.7083 2.08203H7.29167C6.96824 2.08203 6.64925 2.15734 6.35997 2.30199C6.07069 2.44664 5.81906 2.65667 5.625 2.91543L3.54167 5.69378Z" />
    </svg>
  );
};
